<style scoped lang="less">
  .group {
    border: 1px solid #dedede;
    padding: 5px;
    transition: all .3s;
    border-radius: 5px;
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: column;
    &.active {
      border-color: #2E6BE5;
    }
    .title {
    }
    & + .group {
      margin-top: 20px;
    }
  }
  .group-table {
    flex: 1;
    height: 0;
    position: relative;
  }
  .md-name {
    font-size: 14px;
    color: #606266;
  }
  .md-type {
    color: #9ea7b4;
    font-size: 12px;
  }
</style>

<template>
  <!-- 饮片 -->
  <div>
    <div class="group" :class="{active: activeIndex === i}" v-for="(item, i) in groups" :key="i" @click="activeIndex = i">
      <div class="title">
        <fm-form inline>
          <fm-form-item label="总剂数">
            <fm-input-number :min="1" style="width: 100px" v-model="item.timesNum"></fm-input-number>
          </fm-form-item>
          <fm-form-item label="用药频率">
            <fm-select v-model="item.usageFrequency" @change="item.setUsageFrequency()" clearable filterable placeholder="请选择用药频率">
              <fm-option v-for="(t, i) in usageFrequency" :key="i" :value="t" :label="t"></fm-option>
            </fm-select>
          </fm-form-item>
        </fm-form>
      </div>
      <div class="group-table" ref="table" :xxx="'(' + String(tableHeight) + ')'">
        <Table :height="tableHeight" :columns="columns" :data="item.list" no-data-text="暂无数据">
          <div slot="mdinfo" slot-scope="{ row }">
            <div class="md-name">{{row.medichine.mainbodyMedicine ? row.medichine.mainbodyMedicine.medicineName : row.medichine.name}}</div>
            <div class="md-type">{{row.medichine.mainbodyMedicine ? row.medichine.mainbodyMedicine.medicineManufacturer : row.medichine.manufacturer}}</div>
          </div>
          <div slot="volume" slot-scope="{ row, index }">
            <fm-input-number size="small" style="width: 80px;" :min="1" @input="v => {$set(item.list[index], 'volume', v); $set(item.list[index], 'amount', (row.volume * row.price).toFixed(2))}" v-model="row.volume" />
          </div>
          <div slot="amount" slot-scope="{ row }">{{row.amount}}</div>
          <fm-select style="width: 100%" slot="usage" slot-scope="{ row, index }" @change="v => $set(item.list[index], 'medicineUsage', v)" v-model="row.medicineUsage" clearable filterable placeholder="请选择用法">
            <fm-option v-for="(t, i) in usage" :key="i" :value="t" :label="t"></fm-option>
          </fm-select>
          <origin slot="origin" slot-scope="{ row }" :data="row.origin" />
          <div slot="action" slot-scope="{ index }">
            <Button type="text" @click="delMedichine(index)" size="small">删除</Button>
          </div>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import TableMixins from './mixins'

export default {
  mixins: [TableMixins],
  computed: {
    columns () {
      return [
        { title: '序号', type: 'index', width: 70, fixed: 'left' },
        { title: '饮片名称', key: 'mdinfo', slot: 'mdinfo', fixed: 'left', minWidth: 185 },
        { title: '剂量', key: 'volume', slot: 'volume', minWidth: 130 },
        { title: '单价（元）', key: 'price', minWidth: 120 },
        { title: '金额（元）', key: 'amount', slot: 'amount', minWidth: 120 },
        { title: '用法', key: 'usage', slot: 'usage', minWidth: 150 },
        { title: '来源', key: 'origin', fixed: 'right', slot: 'origin', width: 100 },
        { title: '操作', key: 'action', slot: 'action', fixed: 'right', width: 70 }
      ]
    }
  }
}
</script>
